module.exports = __webpack_public_path__ + "static/media/4.91010f52.png";